module.exports = __webpack_public_path__ + "assets/img/trsq.7bbabb52.png";